import { staticQuery } from 'functions/handleDb'
//import configureStore from '../store/configureStore'

//const appid = configureStore.getState().appgeneral.get('appid')

const getContent = (appid, id) => staticQuery(
    `apps/${appid}/${id}`,
    false
).then(data =>
    data.map(({ name, id }) =>
        ({ value: name, key: id }))
)

const getMasters = (appid, id) => staticQuery(
    `apps/${appid}/mastersData`,
    [{
        field: 'masterid',
        operator: '==',
        value: id
    }]
).then(data =>
    data.map(({ value, id }) =>
        ({ value, key: id }))
)

const getSelectValue = async (appid, { type, id }, value) => {
    let sendValue

    if(value){
        if (type === 'core') {
            sendValue = await getContent(appid, id)
                .then(data => data.find(f => f.key === value))
                .then(result => result.value)
        } else {
            sendValue = await getMasters(appid, id)
                .then(data => data.find(f => f.key === value))
                .then(result => result && result.value)
                .catch(error => console.log('Error: ', error))
        }
    }else {
        sendValue = ''
    }

    return sendValue
}

const getSelectData = (appid, { type, id }) => {

    if (type === 'core') {
        return getContent(appid, id)
    } else {
        return getMasters(appid, id)
    }

}

export {
    getSelectData,
    getSelectValue
}